const SelectPlanIFrame = ({ setIframeStatus, token, countryCode, stateCode, zipCode, signature }) => {
    return (
        <div className='iframe-container'>
            <iframe src={`${process.env.PUBLIC_URL}/ev-select-plan?auth=${token}${countryCode !== "undefined" ? "&countryCode=" + countryCode : ""}${stateCode !== "undefined" ? "&stateCode=" + stateCode : ""}${zipCode !== "undefined" ? "&zipCode=" + zipCode : ""}&signature=${signature}`} title="EV Select Plan" width="100%" height="100%" onLoad={() => setIframeStatus(true)}></iframe>
        </div>
    );
}
export default SelectPlanIFrame;

